import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logoTow.png'
import _imports_1 from '@/assets/qr.png'


const _hoisted_1 = { class: "site-footer" }
const _hoisted_2 = { class: "footer-copyright" }
const _hoisted_3 = { class: "copyright-line" }


export default /*@__PURE__*/_defineComponent({
  __name: 'FooterView',
  setup(__props) {

const currentYear = new Date().getFullYear()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"footer-banner\" data-v-7feba506><div class=\"banner-content\" data-v-7feba506><p class=\"banner-text main-text\" data-v-7feba506>火锅、烤肉、海鲜、油炸、熟食、慕斯蛋糕一站式配齐</p><p class=\"banner-text main-text\" data-v-7feba506>品类齐全 · 品质稳定 · 快捷高效 · 高性价比</p></div></div><div class=\"footer-main\" data-v-7feba506><div class=\"brand-logo\" data-v-7feba506><img src=\"" + _imports_0 + "\" alt=\"\" data-v-7feba506></div><div class=\"qr-wrapper\" data-v-7feba506><img src=\"" + _imports_1 + "\" alt=\"官方微信\" class=\"qr-img\" data-v-7feba506></div></div>", 2)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createTextVNode(" Copyright " + _toDisplayString(_unref(currentYear)) + " qianxizhenxuan.com All Rights Reserved ", 1),
        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "divider" }, "|", -1)),
        _cache[1] || (_cache[1] = _createElementVNode("a", { href: "https://beian.miit.gov.cn/#/Integrated/index" }, "豫ICP备2026011238号-1", -1)),
        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "divider" }, "|", -1)),
        _cache[3] || (_cache[3] = _createElementVNode("a", { href: "https://beian.mps.gov.cn/#/query/webSearch" }, "豫公网安备41010802002556号", -1))
      ]),
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "company-name" }, "河南千喜臻选商贸有限公司 版权所有", -1))
    ])
  ]))
}
}

})